import { render, staticRenderFns } from "./ParagraphEdit.vue?vue&type=template&id=a37ffb90"
import script from "./ParagraphEdit.vue?vue&type=script&lang=js"
export * from "./ParagraphEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports